import { InstanceState } from '../instance-service/instance-state.service';
import { StateServices } from '../instance-service/i-state-services';
import { Vector3 } from 'three/src/math/Vector3.js';
import { Action, MemoizedSelector } from '@ngrx/store';
import { FunctionIsNotAllowed } from '../instance-service/state-utils/instanceActionGroup';
import { RenderServices } from '../instance-service/i-render-services';
import { Entity } from 'src/app/state/entities/entity.model';
import {InstanceService} from "../instance-service/instance.service";
import {NetworkServices} from "../instance-service/i-network-services";
import {IMetadata} from "../instance-service/i-metadata";
import {BlueprintContext} from "./i-blueprint-context";

export enum InitType {
  Found = 'Found',
  Created = 'Created'
}


export abstract class Blueprint {
  abstract type: string; // e.g. 'Spaceship', 'Planet'
  abstract id: string;
  state: InstanceState<any, any, any, any>

  abstract init(config: {
    initType: InitType,
    metadata: IMetadata
  } & BlueprintContext): any

  abstract updatePosition(config: {
    newPos: Vector3
  }): any

  abstract destroy(): void
  
  public dispatch<V extends Action = Action>(action: V & FunctionIsNotAllowed<V, 'Functions are not allowed to be dispatched. Did you forget to call the action creator function?'>): void {
    this.state.dispatch(action as Action)
  }

  public select<T>(
    selector: MemoizedSelector<object, T | undefined | null>,
  ) {
    return this.state.select(selector)  
  }
}

